import React from 'react';
import Header from '../header/Header';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    return (
        <div>
            <Header />
            <div className="privacy-container">
                <div className="privacy-glass-card">
                    <h1>Privacy Policy</h1>
                    <p style={{ color: '#ccc', fontStyle: 'italic', marginBottom: '20px' }}>Last updated: March 18, 2026</p>
                    
                    <p>At <strong>Tape Signal</strong>, accessible from tapesignal.com, one of our main priorities is the privacy of our visitors and customers. This Privacy Policy document contains types of information that is collected and recorded by Tape Signal and how we use it regarding our digital audio plugins.</p>
                    
                    <p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us through email at <strong>support@tapesignal.com</strong>.</p>
                    
                    <h3 style={{ color: 'white', marginTop: '20px' }}>Information We Collect</h3>
                    <p>When you register for an account or purchase a plugin (like Aurora, Refract, or Duck), we collect the following personal information:</p>
                    <ul style={{ color: '#a0a0a0', lineHeight: '1.6' }}>
                        <li>Your Name and Email Address</li>
                        <li>Unique Machine IDs used strictly for license generation and anti-piracy validation.</li>
                        <li>Payment processing data (handled securely via our third-party processors Stripe/Rapyd; we do not store full credit card numbers).</li>
                    </ul>

                    <h3 style={{ color: 'white', marginTop: '20px' }}>How We Use Your Information</h3>
                    <p>We use the information we collect in various ways, including to:</p>
                    <ul style={{ color: '#a0a0a0', lineHeight: '1.6' }}>
                        <li>Provide, operate, and maintain our website and plugin delivery network.</li>
                        <li>Improve, personalize, and expand our ecosystem.</li>
                        <li>Understand and analyze how you use our website (via Google Analytics).</li>
                        <li>Develop new products, services, features, and native audio algorithms.</li>
                        <li>Communicate with you for customer service, updates, and plugin releases.</li>
                        <li>Process transactions and prevent fraud.</li>
                    </ul>

                    <h3 style={{ color: 'white', marginTop: '20px' }}>Third-Party Policies & Tracking</h3>
                    <p>Tape Signal employs standard analytics (Google Analytics) and tracking pixels (Facebook Pixel) to understand traffic and run marketing campaigns. These third-party ad servers or ad networks use technologies like cookies, JavaScript, or Web Beacons that are sent directly to users' browsers. You can choose to accept or decline these non-essential cookies using our site's Cookie Banner.</p>

                    <h3 style={{ color: 'white', marginTop: '20px' }}>GDPR & CCPA Rights</h3>
                    <p>Under the GDPR and CCPA, you have the right to request copies of your personal data, request correction of inaccurate information, or request the erasure of your personal data. To exercise any of these rights, please contact us.</p>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
